function checkFadeupElements() {
  const windowTop = window.scrollY;
  const windowHeight = window.innerHeight;
  const windowBottom = windowTop + windowHeight;
  const triggerPosition = windowTop + windowHeight * 0.4;

  document.querySelectorAll('.js-fadeup').forEach(function (el) {
    const elementTop = el.getBoundingClientRect().top + window.scrollY;

    // 下からふわっと
    if (elementTop < windowBottom - 50) {
      el.classList.add('is-inview');
    }

    // 高さ半分で画像切替
    if (elementTop < triggerPosition) {
      el.classList.add('is-inview--half');
    } else {
      el.classList.remove('is-inview--half');
    }
  });
}

window.addEventListener('scroll', checkFadeupElements);
window.addEventListener('load', checkFadeupElements);
